import React from 'react';
import { Alert, Button, Stack, TextField, Typography } from '@mui/material';
import { PlayerCardLayout } from '../../components/PlayerCardLayout';

export function IntroPage({ sessionStatus, header, name, setName, onJoin, joining, error }) {
  return (
    <PlayerCardLayout header={header}>
      <Typography>{sessionStatus?.introText || 'Dobrodošli u kviz.'}</Typography>
      <Typography>Igrači: {sessionStatus?.joinedDisplay || '0/0'}</Typography>
      <Typography variant="body2" color="text.secondary">{sessionStatus?.joinedCount ?? 0} prijavljena od ukupno {sessionStatus?.enabledPlayersCount ?? 0} uključenih natjecatelja.</Typography>
      <TextField fullWidth label="Unesi svoje ime" value={name} onChange={(event) => setName(event.target.value)} />
      {error && <Alert severity="error">{error}</Alert>}
      {sessionStatus?.status !== 'running' && <Alert severity="info">Igra još nije pokrenuta. Pričekajte administratora.</Alert>}
      <Stack direction="row" spacing={2}>
        <Button variant="contained" disabled={joining || sessionStatus?.status !== 'running'} onClick={onJoin}>Počni</Button>
      </Stack>
    </PlayerCardLayout>
  );
}
